import * as R from 'ramda';
import { reduxHelper } from 'utils/reduxHelper';

import {
    MCS_SERVICES,
    PermissionSelectors,
} from 'reactApp/modules/PermissionsModule/PermissionsModule';
import { ProjectSelectors } from 'reactApp/modules/ProjectModule';
import { WhiteLabelSelectors } from 'reactApp/modules/WhiteLabelModule/WhiteLabelModule';

const viewService = (state) => {
    return R.allPass([
        PermissionSelectors.checkPermissions({
            view: [MCS_SERVICES.billing],
        }),
        WhiteLabelSelectors.getIsBillingEnabled,
    ])(state);
};

const pay = R.allPass([
    viewService,
    ProjectSelectors.getCanPay,
    WhiteLabelSelectors.getHasAvailablePaymentMethods,
    PermissionSelectors.checkPermissions({
        modify: [MCS_SERVICES.billing],
    }),
]);

const bindCard = pay;

export const BillingPermissionsSelectors = {
    getPermissions(state) {
        return {
            viewService: viewService(state),
            pay: pay(state),
            bindCard: bindCard(state),
        };
    },
    getCanViewService: viewService,
    getCanPay: pay,
    getCanBindCard: bindCard,
};

export const BoundBillingPermissionsSelectors = reduxHelper.bindSelectors(
    BillingPermissionsSelectors,
);
